import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _excluded = ["data-testid", "children", "value", "secondaryContent", "labelProps", "activeColor"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _RadioContainer;

import React from 'react';
import { Radio } from 'antd';
import styled from 'styled-components';
import chroma from 'chroma-js';
var LabelContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: ", ";\n  line-height: 1.5rem;\n\n  ", "\n"])), function (props) {
  return props.theme.colors.dark;
}, function (props) {
  return props.block && "\n    width: 100%\n  ";
});
var RadioContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 2.5rem;\n  padding-top: 0.15rem;\n"])));
var FakeRadio = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 1.2rem;\n  height: 1.2rem;\n  background-color: ", ";\n  border: 5px solid ", ";\n  box-shadow: 0 0 0 1px ", ";\n  border-radius: 100%;\n  transition: all ease-in-out 0.1s;\n"])), function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.theme.colors.darkGrey;
});
var RadioButton = styled(Radio.Button)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  &.ant-radio-button-wrapper {\n    height: fit-content;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n    width: 100%;\n    border-radius: 4px;\n    border-left-width: 1px;\n\n    &:not(:first-child), &:last-child {\n      &::before {\n        display: none;\n      }\n    }\n\n    &:not(:last-child) {\n      margin-bottom: 1rem;\n    }\n\n    & > span {\n      display: flex;\n      flex-direction: row;\n\n      ", "\n    }\n\n    &.ant-radio-button-wrapper-checked {\n      &:not(.ant-radio-button-wrapper-disabled) {\n        &, &:hover {\n          background-color: ", ";\n          border-color: ", ";\n          ", " {\n            color: ", ";\n          }\n        }\n      }\n\n      > span:nth-child(2) > ", " > ", " {\n        background-color: ", ";\n        border: 3px solid ", ";\n        box-shadow: 0 0 0 1px ", ";\n      }\n    }\n  }\n"])), function (props) {
  return props.align === 'middle' ? "\n      align-items: center;\n      " : '';
}, function (props) {
  return chroma(props.theme.colors[props.activeColor]).alpha(0.075).hex();
}, function (props) {
  return props.theme.colors[props.activeColor];
}, LabelContainer, function (props) {
  return props.theme.colors[props.activeColor];
}, RadioContainer, FakeRadio, function (props) {
  return props.theme.colors[props.activeColor];
}, function (props) {
  return props.theme.colors.light;
}, function (props) {
  return props.theme.colors[props.activeColor];
});
RadioButton.defaultProps = {
  activeColor: 'primary'
};
var Title = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-weight: bold;\n"])));
var Subtitle = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 0.9rem;\n"])));

var RadioCard = function RadioCard(_ref) {
  var dataTestId = _ref['data-testid'],
      children = _ref.children,
      value = _ref.value,
      _ref$secondaryContent = _ref.secondaryContent,
      secondaryContent = _ref$secondaryContent === void 0 ? '' : _ref$secondaryContent,
      _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
      _ref$activeColor = _ref.activeColor,
      activeColor = _ref$activeColor === void 0 ? 'primary' : _ref$activeColor,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(RadioButton, _extends({
    "data-testid": dataTestId,
    activeColor: activeColor,
    value: value
  }, otherProps), _RadioContainer || (_RadioContainer = /*#__PURE__*/React.createElement(RadioContainer, null, /*#__PURE__*/React.createElement(FakeRadio, null))), /*#__PURE__*/React.createElement(LabelContainer, labelProps, secondaryContent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, null, children), /*#__PURE__*/React.createElement(Subtitle, null, secondaryContent)) : children));
};

export default RadioCard;